export default __webpack_public_path__ + "static/media/promo_spatial_audio_billie_eilish__ltg83lkpcqq2_small.d36afd4b.jpg";